<template>
  <div>
    <div class="content" :class="theme==0?'dark':'white'">
      <section class="topTitle">
        <!-- 关于我们 -->
        {{$t('about.aboutUs')}}
        <img src="/static/img/deco_curve@2x.png" alt="">
      </section>
      <article class="about-info">
        <section class="intro">
          <section class="desc">
            薄盒是基于区块链技术的数据操作系统OS产品。操作系统层位于各数据库和用户之间，是两者沟通的桥梁。降低用户使用门槛，且解决开发者复杂繁琐的部署环境。用户能直接从区块链中读取数据，不依赖任一主体。解决数据孤岛，是支持多用户、多平台、多区块链、实时的操作面板。
          </section>
          <section class="contact">
            <p class="tel">
              <span>
                <!-- 联系电话： -->
                {{$t('about.des2')}}
              </span>
              <span>010-85512199</span>
            </p>
            <p class="email">
              <span>
                <!-- 联系邮箱： -->
                {{$t('about.des3')}}
              </span>
              <span>info@mints.cn</span>
            </p>
            <p class="email">
              <span>
                违法和不良</br>信息举报邮箱：
              </span>
              <span>blxxjb@mints.cn</span>
            </p>
            <p class="address">
              <!-- <span>公司地址：</span>
                <span>北京市朝阳区八里庄北里129号院9号楼14层1单元1402</span> -->
            </p>
          </section>
        </section>
        <section class="map">
          <img src="/static/img/ic-map.png" alt="map">
        </section>
      </article>
    </div>
  </div>
</template>
<script>
  export default {
    name: "about",
    data() {
      return {
        theme: 0,
      }
    },
    mounted() {
      window.scrollTo(0, 0);
      if (this.$route.query.theme) {
        this.theme = this.$route.query.theme
        console.log(this.theme)
      }
    }

  }

</script>

<style scoped="scoped" lang="less">
  * {
    margin: 0;
    padding: 0;
  }

  .content {
    padding-bottom: 41px;

  }

  .dark {
    background: #000000;

    .topTitle {
      color: #f5f4f9 !important;
    }

    .about-info {
      color: #f5f4f9 !important;
      background-color: #1a1f1e !important;
    }
  }

  .white {
    background: #ffffff;

    .topTitle {
      color: #333333 !important;
    }

    .about-info {
      color: #333333 !important;
      background-color: #f1f1f1 !important;
    }
  }


  .topTitle {
    color: #f5f4f9;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    padding: 40px 16px;
    background: url('/static/img/deco_circle_text@2x.png') 101% 50% no-repeat;
    background-size: 57px 96px;
  }

  .topTitle img {
    width: 109px;
    height: 9px;
    object-fit: cover;
    margin: 8px auto 0 auto;
    display: block;
  }

  .about-info {
    overflow: hidden;
    background-color: #1a1f1e;
    margin: 0 16px;
    border-radius: 8px;
  }

  .intro {
    padding: 24px 16px;
  }

  .desc {
    font-size: 16px;
    line-height: 1.8;
    text-align: left;
  }

  .contact {
    margin-top: 24px;
  }

  .contact p {
    display: flex;
    line-height: 1.75;
    font-size: 14px;
    text-align: left;
    // align-items: flex-start;
    align-items: flex-end;
  }

  .contact p span:first-child {
    position: relative;
    display: flex;
    align-items: center;
    width: 100px;
    min-width: 100px;
    padding-left: 24px;
  }

  .contact p:not(:last-child) {
    margin-bottom: 12px;
  }

  .contact p span:first-child:before {
    content: "";
    position: absolute;
    left: 0;
    width: 16px;
    height: 16px;
    background-size: 100%;
  }

  .tel span::before {
    background: url('/static/img/ic-phone@2x.png') no-repeat center;
  }

  .email span::before {
    background: url('/static/img/ic-mail@2x.png') no-repeat center;
  }

  .address span::before {
    background: url('/static/img/ic-spot-line@2x.png') no-repeat center;
  }

  .map {
    width: 100%;
    height: 495px;
  }

  .map img {
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/about.vue